import { config } from "./config";

const googleFirebaseConfig = {
    apiKey: "AIzaSyBg1v2MA5QnY4e2buOkc0u7zlszkcWl6Dc",
    authDomain: "wix-reviews.firebaseapp.com",
    projectId: "wix-reviews",
    storageBucket: "wix-reviews.appspot.com",
    messagingSenderId: "626380891293",
    appId: "1:626380891293:web:25fffde9eb7a8607e0e074"
};

const trustpilotFirebaseConfig = {
    apiKey: "AIzaSyASmQvwRzEfEjeNkZdo56BMJbgHGiP-a9Y",
    authDomain: "wix-trustpilot-reviews.firebaseapp.com",
    projectId: "wix-trustpilot-reviews",
    storageBucket: "wix-trustpilot-reviews.firebasestorage.app",
    messagingSenderId: "1721268271",
    appId: "1:1721268271:web:3420c3b5e775472782aeda"
};

if (config.isTrustpilot) {
    console.log('Trustpilot loaded');
}


export default config.isTrustpilot ? trustpilotFirebaseConfig : googleFirebaseConfig;